























import { Component, Vue, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { Hooper, Slide } from 'hooper';
import 'hooper/dist/hooper.css';
import { IGame } from '~/store/games/types';

@Component({ components: { Hooper, Slide } })
export default class AboutUsNewsArticle extends Vue {
  @State(games => games.games, { namespace: 'games' })
  games!: IGame[];

  gamesToDisplay: IGame[] = [];

  settings = {
    itemsToShow: 2,
    infiniteScroll: true,
    wheelControl: false,
    autoPlay: true,
    playSpeed: 4000,
    breakpoints: {
      600: {
        itemsToShow: 3,
      },
      1000: {
        itemsToShow: 4,
      },
      1500: {
        itemsToShow: 5,
        autoPlay: false,
      },
    },
  };

  mounted() {
    this.gamesToDisplay = this.games.filter(game => {
      return (
        game.aboutUsImage.length > 0 &&
        game.showGamePage &&
        !game.isTotallyBlocked
      );
    });
  }
}
